import React from 'react';
import styles from './StanLoader.module.css';
import { cn } from '@/lib/utils/cn';

interface StanLoaderProps {
    animationDuration?: number;
    dotSize?: number;
    dotsNum?: number;
    color?: string;
    className?: string;
}

export const StanLoader: React.FC<StanLoaderProps> = ({
    animationDuration = 1000,
    dotSize = 15,
    dotsNum = 3,
    color = 'var(--bg-color-primary-brand-main)',
    className = '',
}) => {
    const horizontalMargin = dotSize / 2;

    const spinnerStyle: React.CSSProperties = {
        height: `${dotSize}px`,
        width: `${(dotSize + horizontalMargin * 2) * dotsNum}px`,
    };

    const dotStyle: React.CSSProperties = {
        animationDuration: `${animationDuration}ms`,
        width: `${dotSize}px`,
        height: `${dotSize}px`,
        margin: `0 ${horizontalMargin}px`,
        borderWidth: `${dotSize / 5}px`,
        borderColor: color,
    };

    const dotsStyles: React.CSSProperties[] = [];
    const delayModifier = 0.3;
    const basicDelay = 1000;

    for (let i = 1; i <= dotsNum; i++) {
        const style: React.CSSProperties = {
            ...dotStyle,
            animationDelay: `${basicDelay * i * delayModifier}ms`,
        };
        dotsStyles.push(style);
    }

    return (
        <div
            className={cn(styles.hollowDotsSpinner, className)}
            style={spinnerStyle}
            aria-label='Loading'
            role='status'
        >
            {dotsStyles.map((ds, index) => (
                <div key={index} className={styles.dot} style={ds} />
            ))}
        </div>
    );
};
